import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Check } from 'lucide-react';
import { mockApartmentTypes } from '../mockData';

const LayoutsSection = () => {
  const { t } = useTranslation();
  const [selectedLayout, setSelectedLayout] = useState(0);

  return (
    <section id="layouts" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('layouts.title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            {t('layouts.subtitle')}
          </p>
        </div>

        {/* Layout Type Selector */}
        <div className="flex justify-center gap-4 mb-12 flex-wrap">
          {mockApartmentTypes.map((layout, index) => (
            <Button
              key={layout.id}
              onClick={() => setSelectedLayout(index)}
              variant={selectedLayout === index ? 'default' : 'outline'}
              className={`${
                selectedLayout === index
                  ? 'bg-[#0052CC] hover:bg-[#003366] text-white'
                  : 'border-[#0052CC] text-[#0052CC] hover:bg-blue-50'
              }`}
            >
              {t(`layouts.types.${layout.id}.title`)}
            </Button>
          ))}
        </div>

        {/* Selected Layout Details */}
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <img
              src={mockApartmentTypes[selectedLayout].image}
              alt={t(`layouts.types.${mockApartmentTypes[selectedLayout].id}.title`)}
              className="rounded-lg shadow-xl w-full h-auto object-contain bg-white p-4"
            />
          </div>

          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-4">
              {t(`layouts.types.${mockApartmentTypes[selectedLayout].id}.title`)}
            </h3>
            <p className="text-gray-600 mb-6">
              {t(`layouts.types.${mockApartmentTypes[selectedLayout].id}.description`)}
            </p>

            <div className="space-y-3 mb-6">
              <div className="flex items-center gap-2 text-gray-700">
                <Check className="w-5 h-5 text-[#0052CC]" />
                <span>{mockApartmentTypes[selectedLayout].bedrooms} {t('layouts.bedrooms')}</span>
              </div>
              <div className="flex items-center gap-2 text-gray-700">
                <Check className="w-5 h-5 text-[#0052CC]" />
                <span>{mockApartmentTypes[selectedLayout].bathrooms} {t('layouts.bathrooms')}</span>
              </div>
              <div className="flex items-center gap-2 text-gray-700">
                <Check className="w-5 h-5 text-[#0052CC]" />
                <span>{t('layouts.area')}: {mockApartmentTypes[selectedLayout].area}</span>
              </div>
              <div className="flex items-center gap-2 text-gray-700">
                <Check className="w-5 h-5 text-[#0052CC]" />
                <span>{t('layouts.terrace')}: {mockApartmentTypes[selectedLayout].terrace}</span>
              </div>
            </div>

            <div className="text-3xl font-bold text-[#0052CC] mb-6">
              {t('layouts.price')}: {t('layouts.from')} €{mockApartmentTypes[selectedLayout].price}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LayoutsSection;